<template>
    <article>
        <ul>
            <li>
                Coroot relies heavily on eBPF, therefore, the minimum supported Linux kernel version is 4.16.
            </li>
            <li>
                eBPF-based continuous profiling utilizes <a href="https://github.com/libbpf/libbpf#bpf-co-re-compile-once--run-everywhere" target="_blank">CO-RE</a>.
                CO-RE is supported by most modern Linux distributions, including:
                <ul>
                    <li>Ubuntu 20.10 and above</li>
                    <li>Debian 11 and above</li>
                    <li>RHEL 8.2 and above</li>
                </ul>
            </li>
            <li>
                Coroot gathers metrics, logs, traces, and profiles, with each telemetry signal associated with containers.
                In this context, a container refers to a group of processes running within a dedicated cgroup.
                The following container types are supported:
                <ul>
                    <li>
                        Kubernetes Pods using Docker, Containerd, or CRI-O as their runtime environment
                    </li>
                    <li>
                        Standalone containers: Docker, Containerd, CRI-O
                    </li>
                    <li>
                        Docker Swarm
                    </li>
                    <li>
                        Systemd units: any systemd service is also considered as a container
                    </li>
                </ul>
            </li>
            <li>
                Supported container orchestrators include:
                <ul>
                    <li>Kubernetes: Self-managed, EKS (including basic support for AWS Fargate), GKE, AKS, OKE</li>
                    <li>OpenShift</li>
                    <li>K3s</li>
                    <li>MicroK8s</li>
                    <li>Docker Swarm</li>
                </ul>
            </li>
            <li>
                Limitations:
                <ul>
                    <li>Coroot doesn't support Docker-in-Docker environments such as MiniKube due to <a href="https://github.com/coroot/coroot/issues/10#issuecomment-1345201225" target="_blank">eBPF limitations</a></li>
                    <li>WSL (Windows Subsystem for Linux) is not yet supported</li>
                </ul>
            </li>
        </ul>
    </article>
</template>

<script>

export default {
    data() {
        return {}
    },
    computed: {},
}
</script>

<style scoped>
</style>
